import {Map} from 'immutable';

import Passage from './Passage';

export default Map({
  renderer: Passage,
  type: 'passage',
  label: 'Passage'
});
